module.exports = __webpack_public_path__ + "img/delivery-bg.ef815cd3.jpg";